import { Injectable, inject, OnInit, Inject, NgModule } from '@angular/core';
import { each, extend, filter, find, findIndex, forEach, get, includes, indexOf,
  isEmpty, isEqual, isFunction, keys, map, remove, some, split, startsWith,
  toNumber, uniq, without, toLower, intersection, set, reject } from 'lodash-es';

import { BaseComponent } from '@wms/app/components';
import { runtimeEventManager, getVariableNameFromExpr, replace, prettifyLabel, $invokeWatchers, isDefined } from '@wm/core';
import {
  StudioUtils,
  getDataSetWidgets,
  onAccessRolesChange,
  scrollIntoView,
  swapArrayElements,
  getNewEventsObject,
  initCaps,
  getVariableName,
  WIDGET_CONSTANTS,
  extractType,
  getClonedObject,
  getDatePatterns,
  isNoDoubleQuoteNotPresent,
  isQuoteNotPresent,
  MarkupManagerService
} from '@wms/app/core';
import { BaseVariableService } from '@wms/app/variables';
import { LiveWidgetUtilsService } from '../liveWidgetUtils/live-widget-utils.service';
import { DialogService } from '../dialog/dialog.service';
import { LiveWidgetMarkupManagerService } from '../liveWidgetsMarkupManager/live-widget-markup-manager.service';
import { BindVariableService } from '../bind-variable/bind-variable.service';
import { NotificationService } from '../notification/notification.service';
import { TypeFactoryService } from "@wms/services";
import { SecurityService } from '@wms/settings/security'
import { LiveVariableUtils } from "@wavemaker/variables";
import { PageWsService } from '@wms/workspace';
import { Subject } from 'rxjs';

@Injectable()
export class LiveWidgetSettingsService extends BaseComponent {
  everyoneRole = ['Everyone'];
  deleteMessages = ['confirmdelete', 'deletemessage'];
  gridMessages = ['confirmdelete', 'errormessage'];
  propertiesChanged: string[] = [];
  EVENT_ARGS = {
    'ITEM': '(row)',
    'EVENT': '($event)',
    'ROWEVENT': '($event, row)',
    'ROWDATA': '($event, widget, row)',
    '_ROWDATA': '($event, widget, row)',
    'ROWDETAILEVENT': '($event, widget, row, $data)'
  };
  defaultNgClassesConfig = { 'className': '', 'condition': '' };

  designerTypes = {
    'TABLE': 'TABLE',
    'LIVEFORM': 'LIVEFORM',
    'LIVEFILTER': 'LIVEFILTER',
    'FORM': 'FORM',
    'CHART': 'CHART'
  }
  activeWidgetScope: any;
  shadowProperties: any;
  designerType: any;
  basicPropertyGroups: any;
  advancedPropertyGroups: any;
  actionspositions = [{ 'label': 'Footer', 'value': 'footer' }, { 'label': 'Header', 'value': 'header' }];
  showdateandtimePickerOptions = [{ "label": "Default(Input & Button)", "value": "default" }, { "label": "Button Only", "value": "button" }];
  autoCloseOptions = [{ "label": "Outside Click", "value": "outsideClick" }, { "label": "Always", "value": "always" }, { "label": "Disabled", "value": "disabled" }];
  showDataEntryModeOptions = [{ "label": "Default (Date/DateTime/Time Picker & Input)", "value": "default" }, { "label": "Date/DateTime/Time Picker Only", "value": "picker" }];
  buttonTypes = ['button', 'submit', 'reset'];
  rowPositionOptions = [{ "label": "first", "value": "0" }, { "label": "last", "value": "-1" }];
  rowDetailEventOptions = ["onBeforerowexpand", "onRowexpand", "onBeforerowcollapse", "onRowcollapse"];
  timeGroupOptions = [{ "name": "TIME", "groupOptions": { "hour": "hour", "day": "day", "week": "week", "month": "month", "year": "year" } }];
  timeNonGroupOptions = [{ "labelkey": "LABEL_ALPHABET", "value": "alphabet" }, { "labelkey": "LABEL_WORD", "value": "word" }];
  datePatterns: any = [];
  eventOptions: any = [];
  rowDetailTabEventOptions: any = [];
  componentDefnObject: any = {
    'field': [],
    'button': [],
    'isLayout': false,
    'rowActions': [],
    'isSelectAll': {
      'field': {},
      'button': {},
      'rowActions': {}
    },
    'defaultFields': []
  };
  hideRange: any = {
    'checkboxset': true,
    'radioset': true,
    'checkbox': true,
    'string': true,
    'boolean': true,
    'blob': true,
    'character': true,
    'clob': true,
    'text': true
  };
  relatedData: any;
  fieldsList: any;
  otherWdgts: any = [];
  relatedColumnObject: any;
  showActionMessage: boolean;
  selectedComponent: any = {
    'field': {},
    'button': {}
  };
  DIRECTION = {
    'UP': 1,
    'DOWN': 2
  };
  activeTab = {
    type: 'main'
  };
  parseNgClasses: any;
  propertyGroups: any;
  selectedPropertyGroup: any;
  /*Common functions*/
  actions: any;
  actionWidgets = ['button', 'anchor'];
  targetsList = ['_blank', '_self', '_parent', '_top'];
  variableName: any;
  unitOptions = ['px', '%'];
  textAlignOptions = ['left', 'center', 'right'];
  rowactionspositions = [{ 'label': 'First', 'value': '0' }, { 'label': 'Last', 'value': undefined }];
  isSecurityEnabled = false;
  saveDisabled = false;
  filterFields: any = [];
  selectedFileds: any;
  _showDeviceActionMessage: any;
  variableService: BaseVariableService;
  liveWidgetUtils: LiveWidgetUtilsService;
  headerConfig: any[] = [];
  fieldTypeWidgetTypeMap: any;
  definedTypes: any;
  isDatasetWidgets: any;
  isPrefabType: boolean;
  isTemplateBundleType: boolean;
  prevBoundEntity: any;
  rowNgClasses: any;
  dialogService: DialogService;
  liveWidgetMarkupManager: LiveWidgetMarkupManagerService;
  bindVariableService: BindVariableService;
  markupManager: MarkupManagerService;
  securityService: SecurityService;
  contentOptions: any;
  private variableEventOptions: any[];
  private dialogEventOptions: any;
  private prefabEventOptions: any[];
  notificationService: NotificationService;
  typeService: TypeFactoryService;
  pageWsService: PageWsService;
  isDateTimeType: any;
  widgetTypes: any;
  selecticonProp: string;
  showGroupByActionMessage: boolean;
  accessroles: any;
  selectIconBoundVariable: any;
  chartService: any;
  events: any = [
    "onClick",
    "onTap",
    "onMouseenter",
    "onMouseleave",
    "onFocus",
    "onBlur",
    "onChange",
    "onKeypress",
    "onKeydown",
    "onKeyup"
  ]
  matchModes:any;
  widgetTypeOptionsSubject: any = new Subject();


  constructor() {
    super();
    this.variableService = inject(BaseVariableService);
    this.liveWidgetUtils = inject(LiveWidgetUtilsService);
    this.dialogService = inject(DialogService);
    this.liveWidgetMarkupManager = inject(LiveWidgetMarkupManagerService);
    this.bindVariableService = inject(BindVariableService);
    runtimeEventManager.setService('LiveWidgetSettingsService', this);
    this.notificationService = inject(NotificationService);
    this.typeService = inject(TypeFactoryService);
    this.markupManager = inject(MarkupManagerService);
    this.pageWsService = inject(PageWsService);
    this.securityService = inject(SecurityService);
    this.datePatterns = getDatePatterns();
    this.isPrefabType = this.bindVariableService.isPrefabTemplate;
    this.isTemplateBundleType = this.bindVariableService.isTemplateBundleType;
  }

  ngOnChanges() {

  }

  widgetTypeOptionsObservable() {
    return this.widgetTypeOptionsSubject.asObservable();
  }

  initSettings(propPanelInfo: any, widgetType: any): Promise<any> {
    // Security option is not available for prefab and templatebundle projects. So stopping the authinfo call for these.
    if (!this.isPrefabType && !this.isTemplateBundleType) {
      this.updateAccessRoles();
    }
    this.designerType = this.getDesignerType(widgetType);
    /* property groups to group column properties */
    this.propertyGroups = this.getPropertyGroups();
    this.selectedPropertyGroup = this.propertyGroups[0];
    this.actions = this.getActions();
    this.activeWidgetScope = propPanelInfo.activeWidget;
    this.basicPropertyGroups = propPanelInfo.propertyGroups[0];
    this.advancedPropertyGroups = propPanelInfo.advancedPropertyGroup;
    this.shadowProperties = propPanelInfo.shadowProperties;
    this.variableName = this.activeWidgetScope.binddataset && getVariableNameFromExpr(this.activeWidgetScope.binddataset);
    if (this.designerType === this.designerTypes.TABLE) {
      this.headerConfig = this.activeWidgetScope.headerConfig;
      this.propertiesChanged.push('editmode');
    }

    if (this.designerType === this.designerTypes.CHART) {
      this.setValues('key');
    }
    /*Functions common to filter and form*/
    this.fieldTypeWidgetTypeMap = this.liveWidgetUtils.getFieldTypeWidgetTypesMap();
    this.definedTypes = without(keys(this.fieldTypeWidgetTypeMap), 'custom');
    this.isDatasetWidgets = getDataSetWidgets();

    this.updateEventOptions();

    //prepare the ng class conditional expressions for the row
    this.rowNgClasses = this.liveWidgetUtils.parseNgClasses(this.shadowProperties.rowngclass);
    forEach(this.shadowProperties, (value, key) => {
      if (includes(['multiselect', 'radioselect', 'filtermode', 'navigation', 'formposition', 'captionposition', 'showviewlessbutton', 'isrowselectable', 'allowpagesizechange'], key) || includes(this.gridMessages, key)) {
        this.showOrHideProperties(key, value);
      }
    });
    return Promise.resolve();
  }

  getDesignerType(widgetType: any) {
    switch (widgetType) {
      case 'wm-table': return this.designerTypes.TABLE;
      case 'wm-liveform': return this.designerTypes.LIVEFORM;
      case 'wm-livefilter': return this.designerTypes.LIVEFILTER;
      case 'wm-form': return this.designerTypes.FORM;
      case 'wm-chart': return this.designerTypes.CHART;
      default: return;
    }
  }

  populateDisplayValue = (value: any, property: any) => {
    let displayValue = this.selectedComponent.field[property];
    this.selectedComponent.field[property] = displayValue ? (displayValue + " + ' ' + " + value) : value;
  };

  showSubGroup = (subGroup: any) => {
    let widgetProps = this.activeWidgetScope.widgetProps;

    /* Do not show the subgroup if it does not have any properties to be displayed */
    if (!widgetProps || !subGroup.properties) {
      return false;
    }

    /* Check for the properties inside the subgroup that have show property as true. */
    return subGroup.properties.some((propName: any) => {
      return widgetProps[propName] && widgetProps[propName].showindesigner;
    });
  };

  selectMainTab = () => {
    this.activeTab = { type: 'main' };
  };
  selectActionsTab = () => {
    this.showActionMessage = false;
    this.selectPropertyGroup(this.propertyGroups[0]);
    this.activeTab = { type: 'actions' };
  };

  selectFieldsTab = () => {
    this.showActionMessage = false;
    this.selectPropertyGroup(this.propertyGroups[0]);
    this.activeTab = { type: 'fields' };
    this.setDragHandle();
  };

  getSelectedColumns = (data: any) => {
    forEach(data, (fieldData: any) => {
      if (fieldData.isGroup) {
        this.getSelectedColumns(fieldData.columns);
      } else if (fieldData.pcDisplay || fieldData.mobileDisplay || fieldData.tabletDisplay) {
        this.selectedFileds.push(fieldData.field);
      }
    })
  };

  selectRowDetailTab = () => {
    this.selectedFileds = [];
    this.getSelectedColumns(this.headerConfig);
    if (this.selectedFileds.indexOf(this.componentDefnObject?.rowDef?.position) === -1
      && this.componentDefnObject?.rowDef?.position !== '0'
      && this.componentDefnObject?.rowDef?.position !== '-1') {
      this.componentDefnObject.rowDef.position = '0';
    }
  };

  /* function to update the variable holding selected property group */
  selectPropertyGroup = (propertyGroup: any) => {
    if (this.componentDefnObject.isLayout) {
      this.selectedComponent.field = get(this.componentDefnObject.field, 0);
      this.componentDefnObject.isLayout = false;
    }
    propertyGroup.active = true;
    this.selectedPropertyGroup = propertyGroup;
  };

  getActions = () => {
    let actions;
    switch (this.designerType) {
      case this.designerTypes.LIVEFORM:
        actions = ['cancel()', 'reset()', 'save()', 'saveAndNew()', 'saveAndView()', 'delete()', 'new()', 'edit()', 'highlightInvalidFields()'];
        break;
      case this.designerTypes.TABLE:
        actions = ['addNewRow()', 'deleteRow($event)', 'editRow($event)'];
        break;
      case this.designerTypes.LIVEFILTER:
        actions = ['filter()', 'clearFilter()'];
        break;
      case this.designerTypes.FORM:
        actions = ['reset()', 'submit()'];
        break;
    }
    return actions;
  }

  getPropertyGroups = () => {
    let propertyGroups;
    switch (this.designerType) {
      case this.designerTypes.LIVEFORM:
      case this.designerTypes.LIVEFILTER:
      case this.designerTypes.FORM:
        propertyGroups = [
          { name: 'basic' }, { name: 'events' }
        ];
        break;
      case this.designerTypes.TABLE:
        propertyGroups = [
          { name: 'basic', active: true }, { name: 'events' }, { name: 'styles' }, { name: 'advanced' }
        ];
        break;
      case this.designerTypes.CHART:
        propertyGroups = [
          { name: 'basic', active: true }, { name: 'styles' }, { name: 'advanced' }
        ];
        break;
    }
    return propertyGroups;
  }

  //On field click, set the drag handle so that the field can be dragged
  setDragHandle = ($event?: any) => {
    let $target = $event && $($event.target);
    //If event is not passed, set the target as first active element
    if (!$target || !$target.length) {
      $target = $('.list-items.fields-list .tree-node.active .list-title:first');
      if (!$target.length) {
        return;
      }
    }
    //Remove any drag handles present
    $target.closest('.list-items').find('.list-title').removeAttr('ui-tree-handle');
    //Set the drag handle on active element
    $target.parent().find('.list-title').first().attr('ui-tree-handle', '');
  };

  //Get displayname to show in the primary panel
  getDisplayName = (fieldDef: any) => {
    let displayName = fieldDef.displayname || fieldDef.displayName,
      title;
    //If display name is bound or empty, show title
    if (displayName && !startsWith(displayName, 'bind:')) {
      return displayName;
    }
    title = fieldDef.title;
    //If title is bound or empty, show key or field
    if (title && !startsWith(title, 'bind:')) {
      return title;
    }
    return fieldDef.key || fieldDef.field;
  }

  //Function to set select all for fields
  setSelectAll = (componentDef: any, isSelected: boolean, selectedOption: any) => {
    forEach(componentDef, (config) => {
      if (config.isGroup) {
        this.setSelectAll(config.columns, isSelected, selectedOption);
      } else {
        config[selectedOption] = config._isDeleteDisabled ? true : isSelected;
      }
    });
    // let selected = find(componentDef, (config) => {
    //   return config.field === this.selectedComponent?.field?.field
    // });
    // this.selectedComponent.field = selected;
  }

  //Set the _showDeviceActionMessage if action buttons selected are more than two.
  setDeviceActionMessage = (field: any) => {
    if (field === 'button' && this.designerType === this.designerTypes.LIVEFORM && this.projectService.isMobileApplicationType()) {
      this._showDeviceActionMessage = filter(this.componentDefnObject.button, { 'include': true }).length > 2;
    }
  }

  //Disable the save buttons, if the new given field name is duplicate and field is not deleted/removed
  updateSaveDisabled = () => {
    this.saveDisabled = some(this.componentDefnObject.field, (field) => {
      return field.duplicateField && !field.remove && (field.pcDisplay || field.mobileDisplay || field.tabletDisplay);
    });
  }

  //Function to check if all fields are selected
  getAllSelectedFields(componentDef: any, arrElementNotSelected: any, selectedOption: any) {
    let columnCount = 0;
    forEach(componentDef, (config) => {
      if (config.isGroup) {
        columnCount += this.getAllSelectedFields(config.columns, arrElementNotSelected, selectedOption);
      } else {
        columnCount++;
        config[selectedOption] === "true" ? config[selectedOption] = true : '';
        if (config[selectedOption] !== true) {
          arrElementNotSelected.push(config);
        }
      }
    });
    return columnCount;
  }

  /*function to select all elements in the list*/
  selectAll = (field: any, selectedOption: any) => {
    let isSelected = this.componentDefnObject.isSelectAll[field][selectedOption],
      componentDef;
    if (this.designerType === this.designerTypes.TABLE) {
      if (field === 'button') {
        this.setSelectAll(this.componentDefnObject[field], isSelected, selectedOption);
        componentDef = this.componentDefnObject.rowActions;
      } else {
        componentDef = this.headerConfig;
      }
    } else {
      componentDef = this.componentDefnObject[field];
    }
    this.setSelectAll(componentDef, isSelected, selectedOption);
    this.selectedComponent[field][selectedOption] = isSelected;
    this.setDeviceActionMessage(field);
    this.updateSaveDisabled();
  };

  onSelectedCompChange(componentType: 'field' | 'button', selectedKey: string, value: any) {
    this.selectedComponent[componentType][selectedKey] = value;
    let field = this.selectedComponent[componentType];
    let index = findIndex(this.componentDefnObject[componentType], (comp: any) => comp.key === field.key);
    this.componentDefnObject[componentType][index] = field;
  }

  /*function to check if select all should be selected*/
  updateSelectAll = (field: any, selectedOption: any, fieldDef?: any) => {
    let columnCount = 0,
      arrElementNotSelected: any = [],
      componentDef;
    if (field === 'field' && this.designerType === this.designerTypes.TABLE) {
      componentDef = this.headerConfig;
    } else {
      componentDef = this.componentDefnObject[field];
    }
    if (fieldDef) {
      if (this.selectedComponent[field].key === fieldDef.key) {
        this.selectedComponent[field][selectedOption] = fieldDef[selectedOption];
      }
      if (this.designerType === this.designerTypes.TABLE) {
        // updating the componentDefnObject here based on selected item in headerconfig.
        let selectedItem = this.selectedComponent[field];
        if (!isEmpty(selectedItem)) {
          let itemIndex = this.componentDefnObject[field].findIndex((comp: any) => comp.key === selectedItem.key);
          if (itemIndex !== -1) {
            this.componentDefnObject[field][itemIndex] = selectedItem;
          }
        }
      }
    }
    columnCount += this.getAllSelectedFields(componentDef, arrElementNotSelected, selectedOption);
    if (field === 'button' && this.designerType === this.designerTypes.TABLE) {
      arrElementNotSelected = arrElementNotSelected.concat(filter(this.componentDefnObject.rowActions, function (value) {
        columnCount++;
        return value[selectedOption] !== true;
      }));
    }
    this.setDeviceActionMessage(field);
    columnCount = columnCount + this.componentDefnObject?.button?.length;
    this.componentDefnObject.isSelectAll[field][selectedOption] = columnCount && !(arrElementNotSelected.length > 0);
    this.updateSaveDisabled();
  };

  // This function is used to show the match/dateformat/showcount/collapsile propeties by default
  showGroupByProperties = (field: any) => {
    field.showMatch = (field.groupby && field.match) ? true : false;
    field.showDateFormat = (field.match && field.dateformat) ? true : false;
    field.showCount = field.showCollapsible = (field.editWidgetType === 'radioset' || field.editWidgetType === 'checkboxset') && field.groupby ? true : false;
  };

  /*On adding or moving a component, scroll accordingly*/
  focusSelectedComponent = (isInnerElement?: any) => {
    setTimeout(() => {
      let columnDef,
        $element = $('.list-items .list-item.active'),
        $parent = $('.list-items.fields-list');
      //If element, is not at the first level. Scroll should consider the parent element also
      if (isInnerElement) {
        scrollIntoView($element, $parent, '.first-level');
        return;
      }
      if (this.activeTab.type === 'fields') {
        //For fields, node structure is nested. Scroll to the active element on first level.
        columnDef = this.designerType === this.designerTypes.TABLE ? this.headerConfig : this.componentDefnObject.field;
        if (find(columnDef, this.selectedComponent.field)) {
          scrollIntoView($element, $parent);
        }
        return;
      }
      scrollIntoView($element, $parent);
    }, undefined, false);
  };

  saveDesignerSettings = (openScript?: any, eventName?: any) => {
    let designerObj,
      rowOperation,
      colExists,
      config,
      newFieldDefs: any = [],
      newButtonDefs: any = [],
      newProperties: any = [],
      newRowActionDefs: any = [],
      newRowDefs: any = {},
      customActions: any = [],
      deprecatedProps = ['updaterow', 'deleterow', 'insertrow', 'gridsearch', 'readonlygrid'],
      args: any = [],
      removeProps = ['appDefaults', '_value', '_isDeleteDisabled', 'duplicateField', 'include', 'remove', 'widgetTypeOptions', 'ngClasses', 'isDataSetBound', 'isDefinedData', 'value', 'defaultValue',
        'minPlaceholder', 'displayvalue', 'isRowOperation', 'searchPlaceholder', 'target', 'allowBinding', '_maxValue', '_minValue', 'MaxValue', 'MinValue', 'minValue', 'maxValue', '_readonly'],
      populateCustomActions = (action: any, newCustomActions: any, eventArgs: any) => {
        let actions = map(split(action, ';'), (action) => {
          return action.substring(0, action.indexOf('('));
        });
        forEach(newCustomActions, (action) => {
          if (includes(actions, action)) {
            customActions.push(action);
            args.push(eventArgs);
          }
        });
      },
      // This function is used to set the custom actions
      setCustomActions = (columnDef: any) => {
        if (!isEmpty(columnDef.eventNames)) {
          columnDef.eventNames = uniq(columnDef.eventNames);
          forEach(columnDef.eventNames, (eventName) => {
            populateCustomActions(columnDef[eventName], columnDef.customEvents[eventName], this.EVENT_ARGS._ROWDATA);
          });
          columnDef.eventNames = undefined;
          columnDef.customEvents = undefined;
        }
      },
      promise;

    if (this.designerType === this.designerTypes.TABLE) {
      let _columnDef = find(this.componentDefnObject.field, { 'field': this.selectedComponent.field.field });
      if (_columnDef) {
        extend(_columnDef, this.selectedComponent.field);
      }
      if (this.shadowProperties.filteronkeypress && this.shadowProperties.filtermode != 'search') {
        this.shadowProperties.filteronkeypress = false;
      }
    }
    if (this.designerType === this.designerTypes.LIVEFILTER) {
      let _columnDef = find(this.componentDefnObject.field, { 'field': this.selectedComponent.field.field });
      if (_columnDef) {
        extend(_columnDef, this.selectedComponent.field);
      }
    }
    //if save is already in progress, return here
    if (this.saveDisabled) {
      return;
    }
    this.saveDisabled = true; //Disable the save button
    if (this.designerType === this.designerTypes.CHART) {
      this.setValues('value');
      //Updating the markup with properties
      runtimeEventManager.emit('update-widget-properties', {propertiesChanged: this.propertiesChanged, shadowProperties: this.shadowProperties})
      // //Replot the chart with new changes
      runtimeEventManager.emit('wms:replot-chart',this.activeWidgetScope);
      this.dialogService.close('DialogLiveWidgetsDesigner', true);
      return;
    }
    forEach(deprecatedProps, (property) => {
      this.propertiesChanged.push(property);
      this.shadowProperties[property] = undefined;
    });
    forEach(this.propertiesChanged, (property) => {
      newProperties.push({
        key: property,
        value: this.shadowProperties[property]
      });
      // dialogParams.shadowProperties[property] = this.shadowProperties[property]; // TODO
      this.activeWidgetScope[property] = this.shadowProperties[property];
    });
    if (this.propertiesChanged.length) {
      runtimeEventManager.emit('update-shadow-props', this.shadowProperties);
    }
    if (this.designerType === this.designerTypes.TABLE) {
      this.setFieldsFromConfig(this.headerConfig);
      //Find the row operation and add it to the headerconfig
      rowOperation = find(this.componentDefnObject.field, { 'isRowOperation': true });
      //If all columsn are unchecked, remove action columns also
      colExists = rowOperation && find(this.componentDefnObject.field, (col) => {
        return !col.isRowOperation && (col.pcDisplay || col.mobileDisplay || col.tabletDisplay);
      });
      if (rowOperation && colExists) {
        config = {
          'field': rowOperation.field,
          'isPredefined': true
        };
        //Check the row position. Based on start add it at bottom or top
        if (toNumber(rowOperation.rowactionsposition) === 0) {
          this.headerConfig.unshift(config);
        } else {
          this.headerConfig.push(config);
        }
      }
    }
    forEach(this.componentDefnObject.field, (columnDef) => {
      let widgetMap;
      /*push the columnDef only if 'include' is set to true*/
      if ((columnDef.pcDisplay || columnDef.mobileDisplay || columnDef.tabletDisplay) && !columnDef.remove) {
        if (columnDef.isRelated) {
          columnDef.lookupFieldOptions = undefined;
          columnDef.lookupTypeOptions = undefined;
        }
        /*Reset default values, so that these properties will not be saved in markup*/
        columnDef.pcDisplay = columnDef.pcDisplay ? undefined : false;
        columnDef.mobileDisplay = columnDef.mobileDisplay ? undefined : false;
        columnDef.tabletDisplay = columnDef.tabletDisplay ? undefined : false;
        columnDef.isRelated = columnDef.isRelated ? true : undefined;
        columnDef.period = columnDef.period ? true : undefined;
        columnDef.regexp = columnDef.regexp && columnDef.regexp !== '.*' ? columnDef.regexp : undefined;

        columnDef.viewmodewidget = columnDef.viewmodewidget === this.liveWidgetUtils.getDefaultViewModeWidget(columnDef.widget) ? undefined : columnDef.viewmodewidget;
        if (columnDef.widgettype){
          columnDef.widget = columnDef.widgettype
        }
        forEach(removeProps, (prop) => {
          columnDef[prop] = undefined;
        });
        this.setAccessRoles(columnDef);
        if (this.designerType === this.designerTypes.LIVEFORM) {
          setCustomActions(columnDef);
        }
        if (this.designerType === this.designerTypes.TABLE) {
          this.liveWidgetUtils.mergeDimension(columnDef, 'width');
          /*Reset default values, so that these properties will not be saved in markup*/
          columnDef.isRelatedPk = columnDef.isRelatedPk ? true : undefined;
          columnDef.sortable = startsWith(columnDef.sortable, 'bind:') ? columnDef.sortable : (columnDef.sortable === true || !isDefined(columnDef.sortable) ? undefined : 'false');
          columnDef.searchable = columnDef.searchable ? undefined : false;
          columnDef.period = columnDef.period ? true : undefined;
          columnDef.editinputtype = columnDef.editinputtype === 'text' ? undefined : columnDef.editinputtype;
          columnDef.filterinputtype = columnDef.filterinputtype === 'text' ? undefined : columnDef.filterinputtype;
          columnDef.showdropdownon = columnDef.showdropdownon === 'default' ? undefined : columnDef.showdropdownon;
          columnDef.dataentrymode = columnDef.dataentrymode === 'default' ? undefined : columnDef.dataentrymode;
          columnDef.autoclose = columnDef.autoclose === 'outsideClick' ? undefined : columnDef.autoclose;
          populateCustomActions(columnDef.widgetConfig && columnDef.widgetConfig.action, columnDef.customActions, this.EVENT_ARGS.ITEM);
          columnDef.customActions = undefined;
          setCustomActions(columnDef);
          if (this.shadowProperties.filtermode === 'multicolumn') {
            widgetMap = this.fieldTypeWidgetTypeMap[columnDef.type];
            //Remove the default widget for a type, so that it wont be saved in markup
            if ((columnDef.filterwidget === (widgetMap && widgetMap[0])) || (columnDef.type === 'boolean' && columnDef.filterwidget === 'select')) {
              columnDef.filterwidget = undefined;
            }
          } else {
            columnDef.filterwidget = undefined;
          }
        }
        /*Set empty values as undefined, so that these properties will not be saved in markup*/
        /*Strigify if there are any objects as values - for query builder*/
        forEach(columnDef, (value, key) => {
          if (key !== 'placeholder' && key !== 'maxplaceholder') {
            columnDef[key] = value === '' ? undefined : (value);
          }
        });
        // converting string undefined value, so that this attr is not added in markup and action col is positioned correctly in the grid
        if (columnDef.rowactionsposition === "undefined") columnDef.rowactionsposition = undefined;
        newFieldDefs.push(columnDef);
      }
    });
    forEach(this.componentDefnObject.button, (buttonDef) => {
      /*push the buttonDef only if "include" is set to true*/
      if (buttonDef.include && !buttonDef.remove) {
        this.setAccessRoles(buttonDef);
        buttonDef.include = buttonDef.remove = undefined;
        buttonDef.position = buttonDef.position === 'footer' || (buttonDef.position.length === 1 && buttonDef.position[0] === 'footer') ? undefined : buttonDef.position;
        populateCustomActions(buttonDef.action, buttonDef.customActions, this.EVENT_ARGS.EVENT);
        buttonDef.customActions = undefined;
        buttonDef.conditionalclass = buttonDef.ngClasses ? this.generateNgClassExpression(buttonDef.ngClasses) : buttonDef.conditionalclass;
        if (!buttonDef.conditionalclass) {
          buttonDef.conditionalclass = undefined;
        }
        buttonDef.ngClasses = undefined;
        newButtonDefs.push(buttonDef);
      }
    });
    forEach(this.componentDefnObject.rowActions, (actionDef) => {
      /*push the buttonDef only if "include" is set to true*/
      if (actionDef.include && !actionDef.remove) {
        this.setAccessRoles(actionDef);
        actionDef.include = actionDef.remove = undefined;
        populateCustomActions(actionDef.action, actionDef.customActions, this.EVENT_ARGS.ROWEVENT);
        actionDef.customActions = undefined;
        actionDef.conditionalclass = actionDef.ngClasses ? this.generateNgClassExpression(actionDef.ngClasses) : actionDef.conditionalclass;
        if (!actionDef.conditionalclass) {
          actionDef.conditionalclass = undefined;
        }
        actionDef.ngClasses = undefined;
        newRowActionDefs.push(actionDef);
      }
    });
    if (!newRowActionDefs.length) {
      remove(newFieldDefs, { type: 'custom', field: 'rowOperations' });//Removing operations column
    }

    newRowDefs = this.componentDefnObject.enableRowExpansion === 'true' ? this.componentDefnObject.rowDef : {};
    if (!isEmpty(newRowDefs.eventNames)) {
      newRowDefs.eventNames = uniq(newRowDefs.eventNames);
      forEach(newRowDefs.eventNames, (eventName) => {
        let args = eventName === 'onRowcollapse' ? this.EVENT_ARGS._ROWDATA : this.EVENT_ARGS.ROWDETAILEVENT;
        populateCustomActions(newRowDefs[eventName], newRowDefs.customEvents[eventName], args);
      });
      newRowDefs.eventNames = undefined;
      newRowDefs.customEvents = undefined;
    }
    /*Set empty values as undefined, so that these properties will not be saved in markup*/
    /*Strigify if there are any objects as values - fir query builder*/
    forEach(newRowDefs, (value, key) => {
      if (value === '') {
        newRowDefs[key] = undefined;
      }
    });

    designerObj = {
      'type': this.designerType,
      'widgetName': this.activeWidgetScope.name,
      'widgetId': this.activeWidgetScope.widgetId,
      'fieldDefs': newFieldDefs,
      'buttonDefs': newButtonDefs,
      'rowActionDefs': newRowActionDefs,
      'rowDefs': newRowDefs,
      'properties': newProperties,
      'variableName': this.variableName,
      'src': 'designer',
      'numColumns': this.activeWidgetScope.getActiveLayout && this.activeWidgetScope.getActiveLayout(),
      'fromDesigner': true,
      'widgettype': this.activeWidgetScope.widgetType,
      'customActions': uniq(customActions),
      'args': args,
      'openScript': openScript || false,
      'eventName': eventName || undefined,
      'headerConfig': this.headerConfig
    };
    if (this.designerType === this.designerTypes.LIVEFORM) {
      promise = this.liveWidgetMarkupManager.updateMarkupForLiveForm(designerObj);
    } else if (this.designerType === this.designerTypes.LIVEFILTER) {
      promise = this.liveWidgetMarkupManager.updateMarkupForLiveFilter(designerObj);
    } else if (this.designerType === this.designerTypes.TABLE) {
      promise = this.liveWidgetMarkupManager.updateMarkupForGrid(designerObj);
    } else if (this.designerType === this.designerTypes.FORM) {
      promise = this.liveWidgetMarkupManager.updateMarkupForForm(designerObj);
    }
    this.dialogService.close('DialogLiveWidgetsDesigner', true);
    return promise;
  };

  generateNgClassExpression = (conditionalClasses: any, skipBind?: any) => {
    let ngClassExpression = '';
    each(conditionalClasses, (config) => {
      if (config.className && config.condition && !config.errorMsg) {
        if (ngClassExpression.length) {
          ngClassExpression += ', ';
        }
        ngClassExpression += "'" + config.className + "':" + config.condition;
      }
    });
    return ngClassExpression.length ? (skipBind ? '{' + ngClassExpression + '}' :
      'bind:{' + ngClassExpression + '}') : ngClassExpression;
  };

  /* Handle properties like bar spacing, donut ratio and show labels where view and model values differ*/
  setValues(prop: any) {
    this.chartService = runtimeEventManager.getService('chartService');
    let shawdowProperties = this.shadowProperties,
      widgetScope = this.activeWidgetScope;
    //Prop is 'value' in case of save
    //Prop is 'key' in case of intializing
    if (shawdowProperties.barspacing) {
      shawdowProperties.barspacing = this.chartService.getBarSpacingValue(shawdowProperties.barspacing, prop);
      if (prop === 'key') {
        //Need to update both shawdow Properties and widgetScope properties since option need to selected in select
        widgetScope.barspacing = shawdowProperties.barspacing;
      }
    }
    if (shawdowProperties.donutratio) {
      shawdowProperties.donutratio = this.chartService.getRadiusValue(shawdowProperties.donutratio, prop);
      if (prop === 'key') {
        widgetScope.donutratio = shawdowProperties.donutratio;
      }
    }
  }

  //Function to set the access roles
  setAccessRoles(columnDef: any) {
    if (isEqual(columnDef.accessroles, this.everyoneRole) || !columnDef.accessroles) {
      columnDef.accessroles = undefined;
    } else {
      columnDef.accessroles = onAccessRolesChange('accessroles', columnDef.accessroles);
    }
  }
  //As header config is modified in dialog, update component definition with the modified values
  setFieldsFromConfig(headerConfig: any) {
    forEach(headerConfig, (config) => {
      let columnDef;
      if (config.isGroup) {
        this.setFieldsFromConfig(config.columns);
        this.setAccessRoles(config);
      } else {
        columnDef = find(this.componentDefnObject.field, { 'field': config.field });
        if (columnDef) {
          extend(columnDef, config);
        }
      }
    });
  }

  //Function to move the fields by swapping the array based on direction
  moveFields(componentDef: any, selectedComponentIndex: any, direction: any) {
    if (direction === this.DIRECTION.UP) {
      if (selectedComponentIndex === 0) {
        return;
      }
      swapArrayElements(componentDef, selectedComponentIndex, selectedComponentIndex - 1);
    } else {
      if (selectedComponentIndex === componentDef.length - 1) {
        return;
      }
      swapArrayElements(componentDef, selectedComponentIndex, selectedComponentIndex + 1);
    }
  }
  //Function to move the grid fields by swapping the array based on direction
  moveGridFields(headerConfig: any, direction: any, componentType: any) {
    let selectedComponentIndex = findIndex(headerConfig, { 'field': this.selectedComponent[componentType].field });
    //If column is not found, search the inner nodes
    if (selectedComponentIndex > -1) {
      this.moveFields(headerConfig, selectedComponentIndex, direction);
    } else {
      forEach(headerConfig, (config) => {
        if (config.isGroup) {
          this.moveGridFields(config.columns, direction, componentType);
        }
      });
    }
  }

  /*function to move selected component up and down the list*/
  moveSelectedComponent = (direction: any, componentType: any) => {
    if (this.designerType === this.designerTypes.TABLE && componentType === 'field') {
      this.moveGridFields(this.headerConfig, direction, componentType);
      this.focusSelectedComponent();
      this.headerConfig = [...this.headerConfig];
      return;
    }
    let proxyType = componentType,
      selectedComponentIndex = indexOf(this.componentDefnObject[componentType], this.selectedComponent[componentType]);

    if (selectedComponentIndex < 0 && componentType === 'button') {
      proxyType = 'rowActions';
      selectedComponentIndex = indexOf(this.componentDefnObject[proxyType], this.selectedComponent[componentType]);
    }
    this.moveFields(this.componentDefnObject[proxyType], selectedComponentIndex, direction);
    this.focusSelectedComponent();
    this.componentDefnObject.field = [...this.componentDefnObject.field];
    this.componentDefnObject.button = [...this.componentDefnObject.button];
    this.componentDefnObject.rowActions = [...this.componentDefnObject.rowActions];
  };

  showOrHideProperties(property: any, value: any) {
    let widgetProps = this.activeWidgetScope.widgetProps,
      editMode;
    if (this.designerType === this.designerTypes.TABLE) {
      editMode = this.activeWidgetScope.editmode;
      //Show or hide messages based upon the grid edit mode
      if (includes(this.gridMessages, property)) {
        if (!editMode) {
          widgetProps[property].show = widgetProps[property].showindesigner = false;
        } else if (editMode === 'form' || editMode === 'dialog') {
          if (!includes(this.deleteMessages, property)) {
            widgetProps[property].show = widgetProps[property].showindesigner = false;
          }
        }
        return;
      }
      if (property === 'multiselect' || property === 'radioselect') {
        if (!this.shadowProperties.radioselect && !this.shadowProperties.multiselect) {
          widgetProps.isrowselectable.disabled = true;
        } else {
          widgetProps.isrowselectable.disabled = false;
      }
      }
      if (this.activeWidgetScope.editmode === 'quickedit') {
        widgetProps.isrowselectable.showindesigner = widgetProps.isrowselectable.show =false;
      }
      if (property === 'multiselect') {
        if (value) {
          this.shadowProperties.radioselect = false;
          widgetProps.radioselect.disabled = true;
        } else {
          widgetProps.radioselect.disabled = false;
        }
        if(this.variableService.getVariableByName(this.variableName).category === 'wm.Variable'){
            widgetProps.headerselectall.show =widgetProps.headerselectall.showindesigner=value;
        }else{widgetProps.headerselectall.show =widgetProps.headerselectall.showindesigner=false;}
          widgetProps.multiselecttitle.show = widgetProps.multiselecttitle.showindesigner = value
          widgetProps.multiselectarialabel.show = widgetProps.multiselectarialabel.showindesigner = value
      } else if (property === 'radioselect') {
        if (value) {
          this.shadowProperties.multiselect = false;
          widgetProps.multiselect.disabled = true;
        } else {
          if (!this.activeWidgetScope.isPartOfLiveGrid) { //If grid is part of live grid, dont show multiselect
            widgetProps.multiselect.disabled = false;
          }
        }
          widgetProps.radioselecttitle.show = widgetProps.radioselecttitle.showindesigner = value
          widgetProps.radioselectarialabel.show = widgetProps.radioselectarialabel.showindesigner = value
      } else if (property === 'isrowselectable') {
        if (!this.shadowProperties.radioselect && !this.shadowProperties.multiselect) {
          widgetProps.isrowselectable.disabled = true;
        } else {
          widgetProps.isrowselectable.disabled = false;
        }
      }
      else if (property === 'filtermode') {
        widgetProps.searchlabel.show = value === 'search';
        widgetProps.searchlabel.showindesigner = value === 'search';
        widgetProps.filteronkeypress.show = value === 'search';
        widgetProps.filteronkeypress.showindesigner = value === 'search';
        this.propertiesChanged.push(property);
        if(widgetProps.filteronkeypress.value){
          this.propertiesChanged.push('filteronkeypress');
        }
      } else if(property === 'showviewlessbutton') {
        widgetProps.viewlessmessage.show = widgetProps.viewlessmessage.showindesigner = value ? true : false;
      }
      else if (property === 'navigation') {
        widgetProps.showrecordcount.show = widgetProps.showrecordcount.showindesigner = !includes(['None', 'Pager', 'On-Demand', 'Scroll'], value);
        widgetProps.navigationalign.show = widgetProps.navigationalign.showindesigner = value !== 'None';
        widgetProps.ondemandmessage.show = widgetProps.ondemandmessage.showindesigner = includes(['On-Demand'], value);
        widgetProps.showviewlessbutton.show = widgetProps.showviewlessbutton.showindesigner = includes(['Scroll', 'On-Demand'], value);
        widgetProps.viewlessmessage.show = widgetProps.viewlessmessage.showindesigner = !includes(['Scroll', 'On-Demand'], value) ? false : this.shadowProperties['showviewlessbutton'];
        widgetProps.allowpagesizechange.show = widgetProps.allowpagesizechange.showindesigner = !includes(['None', 'On-Demand', 'Scroll'], value);
        widgetProps.pagesizeoptions.show  = widgetProps.pagesizeoptions.showindesigner = widgetProps.allowpagesizechange.show && this.shadowProperties.allowpagesizechange;
      } else if (property === 'formposition') {
        widgetProps.formposition.show = widgetProps.formposition.showindesigner = (editMode !== 'form' && editMode !== 'dialog');
      }else if(property === 'allowpagesizechange'){
        widgetProps.pagesizeoptions.show = widgetProps.pagesizeoptions.showindesigner = value && widgetProps.allowpagesizechange.show;
      }else if(property === 'pagesizeoptions'){
         const  updatedPagesizeoptions =  this.pageWsService.validatePageSizeOptions(value)
         set(this.shadowProperties, property, updatedPagesizeoptions);
      }
    } else {
      if (property === 'captionposition') {
        widgetProps.captionwidth.show = widgetProps.captionwidth.showindesigner = !includes(['top', 'floating'], value);
      }
    }
  }

  shadowPropertyChange = (property: any, value?: any) => {
    this.shadowProperties[property] = value;
    this.showOrHideProperties(property, value);
    if (!includes(this.propertiesChanged, property)) {
      this.propertiesChanged.push(property);
    }

    if (property === 'captionwidth' && this.shadowProperties.captionsize) {
      this.shadowProperties.captionsize = undefined;
      this.propertiesChanged.push('captionsize');
    }
  };

  setActiveProperty = (property: any) => {

  }

  /*clear the property value when we click on clear icon in property panel*/
  clearProperty = (property: any, clearBind?: any) => {
    let bindProperty = this.shadowProperties[property],
      variableName;

    /*Emit the event to update the variable with appropriate binding information.*/
    if (bindProperty.indexOf('bind:Variables.') !== -1) {
      variableName = bindProperty.replace('bind:Variables.', '');
      variableName = variableName.substr(0, variableName.indexOf('.'));
      // TODO: check how to emit value to root
      // $rootScope.$emit('bind-widget-to-variable', variableName, false, $rootScope.domScope);
      //Clearing the bindproperties
      if (clearBind) {
        this.activeWidgetScope['bind' + property] = '';
      }
    }
    this.shadowPropertyChange(property, '');
  };

  openBindVariableDialog = (selectedComponent: any, propertyName: string, componentType?: any, propertyOwnerName?: string, boundContext?: any) => {
    let type = 'string', activeTabName: any,
      boundEntity = selectedComponent[componentType][propertyName];
    if (propertyOwnerName === 'tableRow' && propertyName === 'value') {
      type = 'number, string';
      if (!boundEntity) {
        this.prevBoundEntity = 'bind:Widgets.' + this.activeWidgetScope.name + '.currentItem';
      }
    }
    if (boundContext && (!boundEntity || isEmpty(boundEntity))) {
      activeTabName = boundContext;
    }
    if (includes(['dataset', 'filterdataset'], propertyName)) {
      type = 'array, object';
    } else if (propertyName === 'defaultvalue') {
      switch (selectedComponent.field.editWidgetType) {
        case 'number':
          type = 'number';
          break;
        case 'select':
          type = 'number, string';
          break;
        case 'date':
          type = 'date';
          break;
        case 'datetime':
          type = 'datetime, timestamp';
          break;
        case 'time':
          type = 'time';
          break;
        case 'checkbox':
          type = 'boolean';
          break;
      }
    } else if (includes(['show', 'required', 'disabled'], propertyName)) {
      type = 'boolean, string';
    }
    this.dialogService.open("BindVariable", { customClasses: 'bind-variable-dialog wm-studio-dialog large' });
    this.bindVariableService.dialogParams = {
      addCustomClass: true,
      boundEntity: boundEntity,
      prevBoundEntity: this.prevBoundEntity,
      activeProperty: {
        propertyOwnerName: selectedComponent[componentType].field || selectedComponent[componentType].key || propertyOwnerName,
        propertyDetails: {
          type: type
        },
        name: propertyName
      },
      activePageName: this.pageWsService.activePageName,
      setActiveTabName: activeTabName,
      propertyBindCallback: (boundVariable: any) => {
        selectedComponent[componentType][propertyName] = boundVariable;
        this.prevBoundEntity = boundVariable;
        if (propertyOwnerName === 'tableColumn') {
          this.updateCustomExpression();
        }
      }
    }
  };

  //On value expression change, if expression is present, remove the format patterns
  onExpressionChange = (field: any) => {
    field = field || this.selectedComponent.field;
    if (field.customExpression) {
      field.formatpattern = field.datepattern = field.fractionsize = field.prefix = field.suffix = field.currencypattern = undefined;
    }
  };

  //updates the custom expression when the properties are changed in the UI
  updateCustomExpression = () => {
    let column = this.selectedComponent.field,
      widgetType = column?.widgetType,
      widgetNgClassesExpression = this.generateNgClassExpression(column?.widgetConfig?.ngClasses),
      el = $(column.customExpression),
      attributes: any = {};
    if (!widgetType) {
      return;
    }
    switch (widgetType) {
      case 'image':
        attributes = {
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        //For older projects, image has <img> tag
        if (el.is('wm-picture')) {
          attributes.picturesource = attributes.hint = column.widgetConfig.src;
        } else {
          attributes['data-ng-src'] = attributes.alt = column.widgetConfig.src;
        }
        el.attr(attributes);
        break;
      case 'button':
        attributes = {
          'caption': column.widgetConfig.title,
          'iconclass': column.widgetConfig.icon,
          'on-click': column.widgetConfig.action,
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        el.removeAttr('iconname');
        el.attr(attributes);
        break;
      case 'checkbox':
        attributes = {
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        //For older projects, checkbox has <input type="checkbox">
        if (el.is('wm-checkbox')) {
          attributes.datavalue = column.widgetConfig.model;
          el[0].setAttribute('disabled', column.widgetConfig.disabled);
        } else {
          attributes['ng-model'] = column.widgetConfig.model;
          attributes['ng-disabled'] = column.widgetConfig.disabled;
        }
        el.attr(attributes);
        break;
      case 'label':
        attributes = {
          'caption': column.widgetConfig.title,
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        el.attr(attributes);
        break;
      case 'anchor':
        attributes = {
          'caption': column.widgetConfig.title,
          'hyperlink': column.widgetConfig.hyperlink,
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        el.attr(attributes);
        break;
      case 'icon':
        attributes = {
          'caption': column.widgetConfig.title,
          'iconclass': column.widgetConfig.icon,
          'class': column.widgetConfig.class,
          'conditionalclass': widgetNgClassesExpression,
          'iconposition': column.widgetConfig.iconposition,
          'conditionalstyle': column.widgetConfig.conditionalstyle
        };
        el.attr(attributes);
        break;
    }
    column.customExpression = el[0]?.outerHTML;
    this.onExpressionChange(column);
  };

  openWidgetBindVariableDialog = (widgetProperty: any, propertyName: any, callbackFunction?: any, addCustomClass?: boolean) => {
    this.dialogService.open("BindVariable", { customClasses: 'bind-variable-dialog wm-studio-dialog large' });
    this.bindVariableService.dialogParams = {
      bindMode: 'widget',
      activePageName: this.pageWsService.activePageName,
      boundEntity: this.shadowProperties[propertyName],
      prevBoundEntity: this.prevBoundEntity,
      activeProperty: {
        propertyOwnerName: this.activeWidgetScope.name,
        propertyDetails: widgetProperty,
        name: propertyName
      },
      propertyBindCallback: (boundVariable: any, boundProperty: any, boundVariableType: any) => {
        let bindProperty,
          variableName;
        if (isFunction(callbackFunction)) {
          callbackFunction.apply(null, [widgetProperty, boundVariable]);
        }
        this.prevBoundEntity = boundVariable;
        this.shadowPropertyChange(boundProperty, boundVariable);

        /*Emit the event to update the variable with appropriate binding information.*/
        if (boundVariableType === 'variable') {
          bindProperty = this.shadowProperties[boundProperty];
          variableName = bindProperty.replace('bind:Variables.', '');
          variableName = variableName.substr(0, variableName.indexOf('.'));
          // TODO: check how to emit value to rootScope
          // $rootScope.$emit('bind-widget-to-variable', variableName, true, $rootScope.domScope);
        }
      }
    }
    if (addCustomClass) {
      this.bindVariableService.dialogParams.addCustomClass = true;
    }
  };

  updateNgClasses = (type?: any) => {
    let column;
    if (type === 'row') {
      this.shadowProperties.rowngclass = this.generateNgClassExpression(this.rowNgClasses, true);
      this.shadowPropertyChange('rowngclass', this.shadowProperties.rowngclass);
      return;
    }
    column = this.selectedComponent.field;
    column.ngclass = this.generateNgClassExpression(column.ngClasses, true);
  };

  validateAndUpdateNgClasses = (config: any, type?: any) => {
    let validClass = isQuoteNotPresent(config.className),
      validCondition = isNoDoubleQuoteNotPresent(config.condition);
    config.error = {
      'class': !validClass,
      'condition': !validCondition
    };
    config.errorMsg = !validClass ? this.locale.MESSAGE_ERROR_WIDGET_CLASSNAME_QUOTES_NOT_ALLOWED : (!validCondition ? this.locale.MESSAGE_ERROR_WIDGET_CONDITION_QUOTES_NOT_ALLOWED : '');
    if (validClass && validCondition) {
      this.updateNgClasses(type);
    }
  };
  removeRowConditionalClass = (index: number) => {
    let defaultNgClass = { 'className': '', 'condition': '' };
    if (this.rowNgClasses && this.rowNgClasses.length) {
      this.rowNgClasses.splice(index, 1);
      this.updateNgClasses('row');
    }
    //if the rowngclass is empty after deleting the previous class then add the defaultNgClass
    if (isEmpty(this.rowNgClasses)) {
      this.rowNgClasses.push(defaultNgClass);
    }
  };

  // This function is used to show or hide match property
  showOrHideMatchProperty() {
    let eleScope = this.activeWidgetScope,
      variableName = getVariableName(eleScope),
      field = this.selectedComponent.field,
      selectedVariable = this.variableService.getVariableByName(variableName),
      matchDataTypes = ['string', 'date', 'time', 'datetime', 'timestamp'],
      matchServiceDataTypes = ['java.lang.String', 'java.sql.Date', 'java.sql.Time', 'java.sql.Datetime', 'java.sql.Timestamp'],
      variableCategory = selectedVariable && selectedVariable.category;

    if (!eleScope?.binddataset || field.groupby === WIDGET_CONSTANTS.EVENTS.JAVASCRIPT) {
      this.onEventChange(this.selectedComponent.field, field.groupby, 'field', false, 'groupby');
      return;
    }

    if (!field.groupby || includes(field.groupby, '(')) {
      field.showMatch = false;
    } else if (variableCategory) {
      if (variableCategory === 'wm.LiveVariable') {
        field.showMatch = includes(matchDataTypes, toLower(extractType(this.typeService.getTypeForExpression(eleScope.binddataset + '.' + field.groupby))));
      } else if (variableCategory === 'wm.DeviceVariable') {
        field.showMatch = includes(matchDataTypes, LiveVariableUtils.getFieldType(variableName, field.groupby));
      } else if (variableCategory === 'wm.ServiceVariable' || variableCategory === 'wm.Variable' || variableCategory === 'wm.CrudVariable') {
        field.showMatch = includes(matchServiceDataTypes, this.typeService.getTypeForExpression(eleScope.binddataset + '.' + field.groupby));
      }
    }
    if (!field.showMatch) {
      field.match = '';
    }
    let groupByFlag = (field.groupby ? true : false);

    if (field.widget === 'radioset' || field.widget === 'checkboxset' || field.editWidgetType === 'radioset' || field.editWidgetType === 'checkboxset') {
      field.showCount = groupByFlag;
      field.showCollapsible = groupByFlag;
    }
  };

  // this is used to clear the flags on clear of groupby property
  onClear() {
    this.selectedComponent.field.showMatch = false;
    this.selectedComponent.field.showDateFormat = false;
    this.selectedComponent.field.showCollapsible = false;
    this.selectedComponent.field.showCount = false;
    this.selectedComponent.field.match = '';
    this.selectedComponent.field.dateformat = '';
    this.selectedComponent.field.collapsible = false;
    this.selectedComponent.field.showcount = false;
    this.showActionMessage = false;
  }

  addConditionalClass = (cls: any, config: any, type?: any) => {
    let message,
      emptyClassObj = {
        'className': '',
        'condition': '',
        'isEditing': true
      };
    if (cls.className && cls.condition) {
      this.notificationService.hide();
      if (type === 'row') {
        config.push(emptyClassObj);
      } else {
        config.ngClasses.push(emptyClassObj);
      }
    } else {
      if (!cls.className && !cls.condition) {
        message = this.locale.LABEL_CLASS_NAME + ', ' + this.locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION;
      } else if (!cls.className) {
        message = this.locale.LABEL_CLASS_NAME;
      } else {
        message = this.locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION;
      }
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, replace(this.locale.MESSAGE_WARN_CLASS_NAME_EMPTY, [message]));
    }
  };

  removeConditionalClass = (configType: string, config: any) => {
    let column = this.selectedComponent.field,
      ngClasses = configType === 'field' ? column.ngClasses : configType === 'actionWidget' ? this.selectedComponent.button.ngClasses : column.widgetConfig.ngClasses,
      index = ngClasses.indexOf(config);
    if (index > -1) {
      ngClasses.splice(index, 1);
      /* If all class configs were deleted, then set default empty config. */
      if (!ngClasses.length) {
        ngClasses.push(this.defaultNgClassesConfig);
      }
      if (configType === 'field') {
        this.updateNgClasses();
      } else {
        this.updateCustomExpression();
      }
    }
  };
  // Method to get all the available fields
  getFieldsList = () => {
    if (this.activeWidgetScope.binddataset) {
      //TODO: remove' Bind:' in expression
      if (startsWith(this.activeWidgetScope.binddataset, 'bind:')) {
        return this.typeService.getFieldsForExpr(this.activeWidgetScope.binddataset, { 'filter': 'terminal' });
      }
      return this.typeService.getFieldsForExpr('bind:' + this.activeWidgetScope.binddataset, { 'filter': 'terminal' });
    }
    return [];
  };

  clearBinding = (selectedComponent: any, propertyName: string, defaultValue?: any, propertyOwnerName?: any) => {
    selectedComponent[propertyName] = defaultValue || '';
    if (propertyOwnerName === 'tableColumn') {
      this.updateCustomExpression();
    }
  }

  openIconChooserDialog(selectedProp: any, propName?: any) {
    this.dialogService.open('tableSettingsSelectIconDialog')
    this.selecticonProp = propName;
    this.selectIconBoundVariable = selectedProp;
  }

  handleIconChooserDialogChanges = (iconclass: any) => {
    let selectedProp = this.selectIconBoundVariable;
    if (!this.selecticonProp) {
      selectedProp.iconclass = iconclass;
    }
    if (this.designerType === this.designerTypes.TABLE) {
      this.selecticonProp ? selectedProp[this.selecticonProp] = iconclass : selectedProp.icon = iconclass;
      this.updateCustomExpression();
    }
    this.dialogService.close('tableSettingsSelectIconDialog');
  }

  onEventChange = (componentDef: any, eventValue: any, type?: string, isConfig?: boolean, eventName?: any) => {
    let varDetails: any,
      dialogDetails: any = {},
      eventsObj,
      args = (this.rowDetailEventOptions.indexOf(eventName) > -1 && eventName !== 'onRowcollapse') ? this.EVENT_ARGS.ROWDETAILEVENT : ((type === 'field') ? (isConfig ? this.EVENT_ARGS.ITEM : this.EVENT_ARGS.ROWDATA) :
        (componentDef.hasOwnProperty('position') ? this.EVENT_ARGS.EVENT : this.EVENT_ARGS.ROWEVENT)),
      fieldName;

    //updating event options when variable or action events are created
    if (includes(eventValue,'Variables.') || includes(eventValue, 'Actions.')){
      this.setEventOnDefinition(componentDef, eventValue, type, isConfig, eventName);
      this.updateEventOptions();
    }

    this.setEventOnDefinition(componentDef, eventValue, type, isConfig, eventName);
    if (eventValue === WIDGET_CONSTANTS.EVENTS.NO_EVENT || !intersection(eventValue?.split(';'), WIDGET_CONSTANTS.EVENTS_OPTIONS)) {
      eventName === 'groupby' ? this.showGroupByActionMessage = false : this.showActionMessage = false; //Hiding Info Message
    } else {
      if (includes(eventValue, WIDGET_CONSTANTS.EVENTS.JAVASCRIPT)) { //if category not found return
        eventName === 'groupby' ? this.showGroupByActionMessage = true : this.showActionMessage = true;
        fieldName = componentDef.key || componentDef.field || '';
        fieldName = fieldName.replace(/ /g, '').replace(/\./g, '_');
        fieldName = this.activeWidgetScope.name + '_' + fieldName;
        eventsObj = getNewEventsObject(fieldName + (eventName ? initCaps(eventName) : 'Action'), eventValue?.split(';'), args);
        if (type === 'field' && !isConfig) {
          componentDef.eventNames = componentDef.eventNames || [];
          componentDef.eventNames.push(eventName);
          componentDef.customEvents = componentDef.customEvents || {}; //Create an array with custom actions created by user
          componentDef.customEvents[eventName] = componentDef.customEvents[eventName] || [];
          componentDef.customEvents[eventName] = componentDef.customEvents[eventName].concat(eventsObj.customEvents);
        } else {
          componentDef.customActions = componentDef.customActions || []; //Create an array with custom actions created by user
          componentDef.customActions = componentDef.customActions.concat(eventsObj.customEvents);
        }
        this.setEventOnDefinition(componentDef, eventsObj.events.join(';'), type, isConfig, eventName);
      } else {
        eventName === 'groupby' ? this.showGroupByActionMessage = false : this.showActionMessage = false;
        if (eventValue) {
          varDetails = StudioUtils.getVariableDetails(eventValue);
        }
        if (varDetails?.category) {
          dialogDetails.mode = 'CREATEONLY';
          dialogDetails.source = 'widget';
          // dialogDetails.onSave = onDialogSave;
          // dialogDetails.onCancel = onDialogSaveCancel;
          // $rootScope.$emit("open-variable-dialog", varDetails.type, _.extend(varDetails, dialogDetails));
        }
      }
    }
  }

  //On widget change of an action
  onActionWidgetChange = (buttonDef: any, defaultBtnClass: string) => {
    buttonDef.hyperlink = buttonDef.target = undefined;
    buttonDef.class = buttonDef.widgetType === 'anchor' ? undefined : defaultBtnClass;
  };

  setTragetColumn(val:any){
    this.selectedComponent.field.sortby = val;
  }

  onMappedFieldChange(field: any, key: any, displayName: any, event?: any) {
    if (typeof event === 'object') {
      field[key] = event?.value
    } else {
      field[key] = event
    }
    let fieldNames = map(reject(this.componentDefnObject.field, field), key),
      fieldName = field[key];
    //If field is duplicate, show the error and hint
    if (includes(fieldNames, fieldName)) {
      field.duplicateField = true;
    } else {
      field[displayName] = prettifyLabel(fieldName);
      field.duplicateField = false;
      this.onSelectedCompChange('field', 'key', fieldName);
      this.onSelectedCompChange('field', 'displayName', field[displayName]);
    }
    this.updateSaveDisabled();
  };

  isDuplicateField(newFieldName: string, key: string) {
    let fieldNames = map(reject(this.componentDefnObject.field, this.selectedComponent.field), key);
    if (includes(fieldNames, newFieldName)) {
      return true;
    }
    return false;
  }



  setEventOnDefinition(componentDef: any, eventValue: string, type?: string, isConfig?: boolean, eventName?: any) {
    if (type === 'field') {
      if (isConfig) {
        componentDef.widgetConfig.action = eventValue;
        this.updateCustomExpression();
      } else {
        if (componentDef) componentDef[eventName] = eventValue;
      }
    } else {
      if (componentDef) componentDef.action = eventValue;
    }
  }

  private updateAccessRoles() {
    /*sets the access roles and security flag*/
    /* Check if security is enabled or not from authinfo*/
    (this.securityService.getAuthInfo() as Promise<any>).then((options) => {
      this.isSecurityEnabled = options.enforceSecurity;
      // Set accessroles only when secutiry is enabled.
      if (this.isSecurityEnabled) {
        (this.securityService.getRolesConfig() as Promise<any>).then((accessroles) => {
          this.securityService._rolesConfig = accessroles;
          if (Array.isArray(accessroles)) {
            this.accessroles = accessroles.map((el) => {return el.name;});
          }
        });
      }
    });
  }

  //Get the order of the form fields from the markup as fields may have been moved or new fields were added
  getOrderedFieldsBasedOnMarkUp = (definedFields: any, widgetType: any, parentWidget: any) => {
    let formFields: any = [],
      widgetName = this.activeWidgetScope.name,
      widgetId = this.activeWidgetScope.widgetId;
    filter(this.markupManager.getMarkup()?.find('[name="' + widgetName + '"][widgetid="' + widgetId + '"] ' + widgetType), (field) => {
      let $parentForm = $(field).closest('wm-liveform, wm-form, wm-livefilter');
      if ($parentForm.attr('name') === widgetName && $parentForm.attr('widgetid') === widgetId) {
        let formField = find(definedFields, { 'name': $(field).attr('name') });
        if (formField) {
          formFields.push(formField);
        }
      }
    });
    return formFields;
  }

  //depending on the datatype now generate the other(Not preferred) widgets
  getOtherWdgtTypes = (types: any) => {
    this.widgetTypes = this.liveWidgetUtils.getFieldTypeWidgetTypesMap().custom;
    if (types) {
      this.otherWdgts = [];
      forEach(this.widgetTypes, (widgetType: any) => {
        if (!includes(types, widgetType)) {
          this.otherWdgts.push(widgetType);
        }
      });
    }
  };


  isListWidget = (widgetType: any) => {
    return indexOf(this.liveWidgetUtils.getFieldTypeWidgetTypesMap().list, widgetType) !== -1;
  };

  /*
   * changes the field type based on the lookup column's type
   * accordingly the corresponding widget will be rendered
   */
  onLookupChange = (field: any) => {
    if (field.isRelated) {
      let lookupField = field.lookupField,
        lookupType = field.lookupType,
        nameTypeMap = (this.relatedData[lookupType] && this.relatedData[lookupType].columnNameTypeMap) || {},
        variableObj = this.activeWidgetScope.Variables[this.variableName];
      field.type = nameTypeMap[lookupField] || 'string';
      field.isRange = this.hideRange[field.type] ? false : field.isRange;
      field.matchmode = field.matchmode || (variableObj && variableObj.matchMode);
    }
  };

  // This function is used to show or hide dateformat property
  showOrHideDateformatProperty = () => {
    this.selectedComponent.field.showDateFormat = includes(['day', 'hour', 'month', 'week'], this.selectedComponent.field.match);
  };

  validateAndUpdateExpression = (config: any) => {
    let validClass = isQuoteNotPresent(config.className),
      validCondition = isNoDoubleQuoteNotPresent(config.condition);
    config.error = {
      'class': !validClass,
      'condition': !validCondition
    };
    config.errorMsg = !validClass ? this.locale.MESSAGE_ERROR_WIDGET_CLASSNAME_QUOTES_NOT_ALLOWED : (!validCondition ? this.locale.MESSAGE_ERROR_WIDGET_CONDITION_QUOTES_NOT_ALLOWED : '');
    if (validClass && validCondition) {
      this.updateCustomExpression();
    }
  };

  getMaxLength(property: string) {
    let propertyVal = get(this.activeWidgetScope?.widgetProps, property);
    if (propertyVal?.maxlength == undefined) {
      // TODO: add the max length supported
      return 524288;
    }
    return propertyVal?.maxlength;
  }

  getActiveWidgetPropData(prop: string) {
    return get(this.activeWidgetScope?.widgetProps, prop);
  }

  setAndPropertyChange(property: string, optVal: string) {
    set(this.shadowProperties, property, optVal);
    this.shadowPropertyChange(property, get(this.shadowProperties, property));
  }

  updateEventOptions(){
    this.variableEventOptions = StudioUtils.getVariableOptions();
    this.dialogEventOptions = StudioUtils.getDialogOptions(this.markupManager.getMarkup());
    this.prefabEventOptions = StudioUtils.getPrefabEventOptions();
    /*Populate Event Options*/
    this.eventOptions = [];
    forEach(this.actions, (action: any) => {
      this.eventOptions.push({ 'name': action, 'category': this.locale['LABEL_WIDGET_' + this.designerType] })
    });
    forEach(getClonedObject(WIDGET_CONSTANTS.EVENTS_OPTIONS), (event: any) => {
      this.eventOptions.push({ 'name': event, 'category': 'Default' });
    });

    this.eventOptions = this.eventOptions.concat(this.dialogEventOptions, this.variableEventOptions, this.prefabEventOptions);
    this.rowDetailTabEventOptions = filter(this.eventOptions, (i) => {
      return i?.category !== 'Data Table'
    });
  }
}
